import { render } from "./ApplicationLogo.vue?vue&type=template&id=7fc3cdf7"
const script = {}
script.render = render

export default script